var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundGmBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9686 12.4319C20.2183 10.7507 18.9475 9.84695 17.2099 9.24408L17.7736 6.96671L16.3973 6.62128L15.8486 8.83869C15.4867 8.74779 15.1152 8.66214 14.7459 8.57723L15.2986 6.34519L13.9231 5.99976L13.3591 8.27638C13.0597 8.20772 12.7656 8.13985 12.4803 8.06835L12.4819 8.06118L10.584 7.58379L10.2178 9.06445C10.2178 9.06445 11.2389 9.30021 11.2174 9.31472C11.7748 9.45484 11.8755 9.82645 11.8588 10.121L11.2167 12.7155C11.2551 12.7253 11.3049 12.7395 11.3598 12.7617C11.3139 12.7502 11.265 12.7377 11.2143 12.7255L10.3143 16.3599C10.2462 16.5305 10.0733 16.7864 9.68363 16.6892C9.69742 16.7094 8.68331 16.4378 8.68331 16.4378L8 18.0247L9.79104 18.4744C10.1242 18.5586 10.4507 18.6466 10.7723 18.7294L10.2028 21.0329L11.5775 21.3784L12.1415 19.0993C12.517 19.202 12.8815 19.2967 13.2383 19.386L12.6762 21.6543L14.0526 21.9998L14.622 19.7006C16.9689 20.148 18.7336 19.9676 19.4764 17.8294C20.0749 16.1079 19.4466 15.115 18.2119 14.4675C19.1112 14.2586 19.7885 13.6628 19.9691 12.4321L19.9687 12.4318L19.9686 12.4319ZM16.8241 16.8734C16.3988 18.5949 13.5212 17.6643 12.5883 17.4309L13.3441 14.3792C14.2769 14.6138 17.2686 15.078 16.8242 16.8734H16.8241ZM17.2498 12.407C16.8618 13.9728 14.4667 13.1773 13.6898 12.9822L14.375 10.2145C15.1519 10.4096 17.6539 10.7736 17.2499 12.407H17.2498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundGmBtc);
export default __webpack_public_path__ + "static/media/roundGmBTC.58207790fb37a1cf3c2a03c1dd3d70c9.svg";
export { ForwardRef as ReactComponent };